// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FilterSidebarController from "./filter_sidebar_controller"
import LocationSearchController from "./location_search_controller"
import ContactFormController from "./contact_form_controller"
import BusinessAnalyticsController from "./business_analytics_controller"

application.register("filter-sidebar", FilterSidebarController)
application.register("location-search", LocationSearchController)
application.register("contact-form", ContactFormController)
application.register("business-analytics", BusinessAnalyticsController)
